import {forwardRef, useContext, useEffect, useState} from 'react'

import PropTypes from 'prop-types'

import Context from '@s-ui/react-context'
import {useRouter} from '@s-ui/react-router'
import ModalBasic, {moleculeModalSizes} from '@adv-mt/mt-modal-basic'

const checkHash = (location, hash) => {
  return location.hash.includes(hash)
}

const getUrl = (location, hashName) => {
  const hash = hashName ? `#${hashName}` : ''
  return `${location.pathname}${location.search}${hash}`
}

const ModalWithURLState = forwardRef((props, ref) => {
  const {hash, openModalTrigger, onClose, ...rest} = props
  const {isOpen} = rest

  const {i18n} = useContext(Context)
  const {location, replace: replaceState} = useRouter()
  const [isPopStateChange, setIsPopStateChange] = useState(checkHash(location, hash))

  useEffect(() => {
    if (isPopStateChange) return setIsPopStateChange(false)

    const nextUrl = isOpen ? getUrl(location, hash) : getUrl(location)
    replaceState(nextUrl)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hash, isOpen])

  useEffect(() => {
    const _handlePopState = ev => {
      const hasHash = checkHash(location, hash)
      setIsPopStateChange(true)

      if (hasHash) openModalTrigger()
      else onClose()
    }

    if (checkHash(location, hash)) openModalTrigger()

    window.addEventListener('popstate', _handlePopState)
    return () => window.removeEventListener('popstate', _handlePopState)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hash])

  return (
    <ModalBasic
      ref={ref}
      {...rest}
      title={i18n.t('NAVIGATION_MY_LAST_SEARCHES')}
      onClose={onClose}
      size={moleculeModalSizes.SMALL}
      isInsetScrollArea
    />
  )
})

ModalWithURLState.displayName = 'ModalWithURLState'
ModalWithURLState.propTypes = {
  hash: PropTypes.string.isRequired,
  openModalTrigger: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool
}

export default ModalWithURLState
